module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av230-3bbad41b999351dcce8311d30ae2754b.jpg";